module.exports = require('./helpers/bundle-url').getBundleURL('13ph5') + "perfanalytics.94c5ff60.webp";